import { Component, Input } from '@angular/core';

import { InvoiceModel }   from './models/invoice';
import { InvoiceService } from './invoice.service';

@Component({
  template: require('./invoice.reference.component.html')
})
export class InvoiceReferenceComponent {
  @Input() record: InvoiceModel;

  constructor (
    private invoiceService: InvoiceService
  ) {}

  getReference () : number {
    return this.invoiceService.isStatus(this.record, 'open')
      ? this.record.job_card_number
      : this.record.invoice_number;
  }
}